module.exports = __webpack_public_path__ + "static/img/4.1a3d34b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4.jpg
// module id = saf7
// module chunks = 0